export const assistantQueryKeys = {
  assistantCustomSkills: ['assistant', 'skills'] as const,
  /** Prefix for every chat-history query: the list, each thread, searches. */
  assistantChatThreadsAll: ['assistant', 'threads'] as const,
  assistantChatThreads: ['assistant', 'threads', 'list'] as const,
  assistantChatThread: (threadId: string) => ['assistant', 'threads', 'detail', threadId] as const,
  assistantChatThreadSearch: (query: string) => ['assistant', 'threads', 'search', query] as const,
  /** Prefix for every folder's own thread list. */
  assistantChatFolderThreadsAll: ['assistant', 'threads', 'folder'] as const,
  assistantChatFolderThreads: (folderId: string) =>
    ['assistant', 'threads', 'folder', folderId] as const,
  assistantChatFolders: ['assistant', 'folders'] as const,
  assistantAttachmentLimits: ['assistant', 'attachments', 'limits'] as const,
  assistantChatModels: ['assistant', 'models'] as const,
}
